<template>
  <div class="foot">
    <div class="top">
      <!-- <div class="footLeft">
     <img style="width:auto"  src="../assets/image/logo2.png" alt="">
   </div>
    <href="https://play.google.com/store/apps/details?id=credit.prestamos.personale.cash.deposito.inmediato" -->
      <!-- <a  target="_blank" class="playBtn"><img src="@/assets/image/xz_ico.png" alt=""></a> -->
      <!-- -->
      <div class="column">
        <div class="content">Enlace Rápido</div>
        <a href="/about">
          <div>Sobre Nosotros</div>
        </a>
        <a href="/help">
          <div>Preguntas Frecuentes</div>
        </a>
      </div>
      <div class="column">
        <div class="content">Sobre Ekecash</div>
        <a href="/notice">
          <div>AVISO DE PRIVACIDAD</div>
        </a>
        <a target="blank" href="https://www.ekecash.pe/h5/use.html">
          <div>TÉRMINOS Y CONDICIONES DEL USUARIO</div>
        </a>
      </div>
      <div class="column no_underline">
        <div class="content">Contactos</div>
        <div>Email: servicio@ekecash.pe</div>
        <div>Whatsapp: +51 {{ whatsApp }}</div>
        <div>Número telefónico: +51 {{ phone }}</div>
        <div>
          Horario de Atención: {{ daySection[0] }}<br />{{
            daySection[1] || ""
          }}
        </div>
      </div>
      <!-- <div class="column columnImgLast">
        <div class="content">Descargar</div>
        <a
          href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/EkeCash_google_release_v1.0.22_2306121641.apk"
        >
          <img src="../assets/image/playBtn.png" alt="" />
        </a>
      </div> -->
    </div>
    <!-- <div class="bottom">
      PERUCRED DIGITAL FINANCE SOCIEDAD ANONIMA CERRADA . Todos los derechos reservados
    </div> -->
  </div>
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {
      whatsApp: "",
      phone: "",
      daySection: [],
    };
  },
  mounted() {
    const data = JSON.parse(localStorage.getItem("customerData"));
    this.whatsApp = data.customerServiceWhatsApp.whatsApp;
    this.phone = data.customerServicePhone.phone;
    this.daySection = data.customerServiceWorkTimeInfo.daySection.split(",");
  },
};
</script>
